/**
 * @fileoverview Exchange Rates Prefetch Component
 * 
 * This component prefetches exchange rates on app startup so they're
 * available before any product prices render. It renders nothing but
 * triggers the React Query fetch immediately.
 */

import { useExchangeRates } from '@/hooks/useExchangeRates';

export function ExchangeRatesPrefetch() {
  // This triggers the exchange rates fetch on mount
  // The rates are cached by React Query and available to all components
  useExchangeRates();
  
  return null;
}
